/* eslint-disable */

/*
 * This is a carbon-copy of part of the custom-protocol-check package
 * https://www.npmjs.com/package/custom-protocol-check
 * It was added here so that we have some control over how it's transpiled.
 * For some reason, the package itself was not being correctly transpiled
 */

export const browser = {
  getUserAgent: function () {
    return window.navigator.userAgent;
  },

  userAgentContains: function (browserName = '') {
    browserName = browserName.toLowerCase();
    return this.getUserAgent().toLowerCase().indexOf(browserName) > -1;
  },

  isIOS: function () {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (this.userAgentContains('Mac') && 'ontouchend' in document)
    );
  },

  isOSX: function () {
    return this.userAgentContains('Macintosh');
  },

  isIPad: function () {
    const { platform, maxTouchPoints } = window.navigator;
    return (
      platform === 'iPad' || (platform === 'MacIntel' && maxTouchPoints > 0)
    );
  },

  isIPhone: function () {
    return this.userAgentContains('iphone');
  },

  isFirefox: function () {
    return this.userAgentContains('firefox');
  },

  isInternetExplorer: function () {
    return this.userAgentContains('trident');
  },
  /**
   * Detects IE 11 and older
   * @return {Boolean} Returns true when IE 11 and older
   */
  isIE: function () {
    var ua = this.getUserAgent().toLowerCase();

    // Test values.
    // Uncomment to check result

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko/20100101 Firefox/12.0';

    var msie = ua.indexOf('msie');
    if (msie > 0) {
      // IE 10 or older
      return true;
    }

    var trident = ua.indexOf('trident/');
    if (trident > 0) {
      // IE 11
      return true;
    }

    // other browser
    return false;
  },

  isEdge: function () {
    var ua = this.getUserAgent().toLowerCase();

    // Test values.
    // Uncomment to check result

    // Edge
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2311.135 Safari/537.36 Edge/12.10240';

    var edge = ua.indexOf('edge');
    if (edge > 0) {
      return true;
    }

    return false;
  },

  isChrome: function () {
    // IE11 returns undefined for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // but needs to check if window.opr is not undefined
    // and new IE Edge outputs to true for window.chrome
    // and if not iOS Chrome check
    const isChromium = window.chrome;
    const winNav = window.navigator;
    const vendorName = winNav.vendor;
    const isOpera = typeof window.opr !== 'undefined';
    const isIEedge = winNav.userAgent.indexOf('Edge') > -1;
    const isIOSChrome = winNav.userAgent.match('CriOS');
    return (
      (isChromium !== null &&
        typeof isChromium !== 'undefined' &&
        vendorName === 'Google Inc.' &&
        isOpera === false &&
        isIEedge === false) ||
      isIOSChrome
    );
  },

  isOpera: function () {
    return this.userAgentContains(' OPR/');
  },

  isChromeBook: function () {
    return /(CrOS)/.test(this.getUserAgent());
  },
};

/* eslint-enable */
